<template>
     <div class="skill">
        <!-- <div class="heading2-section">
            Skills
        </div> -->
    <form>
        <div class="badges mb-3">
            <!-- badges -->
             <span class="badge bg-primary badge-container" v-for="skill in skills" :key="skill.skillId">
                <button class="badge-button" @click.prevent="reviewSkill(skill)">{{skill.name}}</button>
                <button type="button" class="btn-close-white ms-2 badge-button-close" @click.prevent="deleteSkillAsync(skill)"><img class="icon" src="../../../assets/icons/close-outline.svg"></button>
            </span>   
            <!--  -->
        </div>
          <div class="mb-3">
            <label class="form-label">Skill</label>
            <input type="text" v-model="skillName" placeholder="Your Skill" class="form-control">
        </div>
        
        <div class="form-buttons mb-3">
            <div class="button-subgroup" v-if="isAdding">
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Adding Skill...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="addSkill()" v-else>Add Skill</button>
            </div>
            <div class="button-subgroup" v-else>
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Updating Skill...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="editSkill()" v-else>Update Skill</button>
                <button type="submit" class="btn btn-default primary-btn badge-cancel"v-if="!loading && !buttonClicked" @click.prevent="cancel()">Cancel Edit</button>
            </div>
        </div>
         <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
    </form>
    <LoadingIndicator v-if="loading"/>
    </div>
    <CustomConfirmationMessageModal :title="modal.caption"
            ref="skillConfirmModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
</template>
<script>
import { addSkillAsync, editSkillAsync, deleteSkillAsync } from '@/services/cvbuilderService';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
export default {
    data(){
        return{
            isAdding: true,
            skillName:"",
             modal:{
                caption:"",
                message:""
            },
            selectedSkillId:"",
            errors:[],
            loading:false,
            buttonClicked:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            modalId:"addSkill"   
        }
    },
    components:{
        CustomConfirmationMessageModal, LoadingIndicator
    },
    computed:{
        skills(){
            var skls = this.$store.getters["cvbuilder/getCVInformation"]?.skills || [];
            return skls;
        }            
    },
    methods:{
         reviewSkill(skill){
            this.isAdding = false;
            this.skillName = skill.name;
            this.selectedSkillId = skill.skillId;
        },
        async addSkill(){   //add skill
            try{     
                var body = {
                    name: this.skillName
                }
                this.resetOnNewSubmit();   
                var data = await addSkillAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/addNewSkill", data.skill);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.skillName = "";
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        async deleteSkillAsync(skill){
            try{     
                this.resetOnBadgeSelection();
                var data = await deleteSkillAsync(skill.skillId);
                if(!data.success){
                    throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/removeSkill",skill.skillId);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.skillName = "";
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        async editSkill(){
            try{     
                var body = {
                    name: this.skillName,
                    skillId: this.selectedSkillId 
                }
                this.resetOnNewSubmit();   
                var data = await editSkillAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/updateSkillName", body);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.skillName = "";
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        cancel(){
            this.skillName = "";
            this.isAdding = true;
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.buttonClicked = true;
                this.hasErrors = false;
                this.errors = [];
        },
         resetOnBadgeSelection(){
                this.loading = true;
                //this.buttonClicked = true; //cause no form button is clicked
                this.hasErrors = false;
                this.errors = [];
        },
        closeModal(){
        if (this.$refs.skillConfirmModal && typeof this.$refs.skillConfirmModal.hide === 'function') {
        this.$refs.skillConfirmModal.hide();
        }
        },
        showModal(){
            this.$refs.skillConfirmModal.show();
        },
         clearErrors(){
            setTimeout(() => {
                this.errors = [];
                this.hasErrors = false;
            }, 3000);          
        }
    }
}
</script>
<style scoped>
    .badges{
        display:flex;
        flex-wrap: wrap;
        row-gap: 0.3rem;
        column-gap:0.3rem;
        /* border: 1px solid black; */
        width: 100%;
        
    }

    .badge{
        display: flex;
        align-items: center;
        border-radius: 100px;
        background-color: var(--primary)!important;
        padding-left: 1rem;
    }
</style>